import { defineNuxtPlugin, useRoute } from '#imports';
import { watch } from 'vue';
import { closeModal } from '~/composables/modal';
import { showPaymentModal } from '~/lib/show-payment-modal';
import { useCartStore } from '~/stores/cart';

const orderStatesWithCancelModal = ['telekom_payment_transferred', 'brodos_payment_transferred'];

export const pagesBlacklist = [
  '/shop/fehler',
  '/shop/zahlungsverifizierung',
  // Join Cart URLS
  '/shop/telekom-bezahlung-information', // 1. Absprung um den Telekom Anteil zu bezahlen
  '/shop/telekom-zahlungsverifizierung', // 2. Verifizierung der Zahlung des Telekom Anteils
  '/shop/telekom-bestaetigung', // 3. Absprung link um den Brodos Anteil zu bezahlen
  '/shop/brodos-zahlungsverifizierung', // 4. Bestätigung des Brodos Anteils
];

// We have 2 cart states, where the customer should be by the payment provider.
// When he comes back to our page, the cart ist "freezed", so we show the customer a modal to "unfreeze" the cart.
export default defineNuxtPlugin((nuxtApp) => {
  const cartStore = useCartStore(nuxtApp.$pinia);

  const route = useRoute();

  watch(
    () => cartStore.cart?.state,
    (newCartState, oldCartState) => {
      // If it is a joint cart, we do not show the modal!
      if (
        !orderStatesWithCancelModal.includes(newCartState || '') ||
        pagesBlacklist.includes(route?.path || '')
      ) {
        // Close modal if open
        if (orderStatesWithCancelModal.includes(oldCartState || '')) {
          closeModal();
        }

        return;
      }

      showPaymentModal();
    }
  );
});
